import React from 'react';
import { CheckCircleIcon, SearchIcon } from 'lucide-react';
export function CourseContentSection() {
  const courseModules = [{
    title: 'Preparación profesional de la uña natural',
    description: 'Domina las bases para un trabajo impecable y duradero'
  }, {
    title: 'Técnicas completas en acrílicas y gel',
    description: 'Aprende paso a paso las técnicas más solicitadas del mercado'
  }, {
    title: 'Diseños virales que enamoran en redes',
    description: 'Crea diseños que se vuelven tendencia y atraen nuevas clientas'
  }, {
    title: 'Evitar problemas comunes y fidelizar clientas',
    description: 'Soluciona problemas antes de que ocurran y gana clientas de por vida'
  }, {
    title: 'Fijar precios y crear paquetes irresistibles',
    description: 'Establece precios rentables y crea ofertas que no puedan rechazar'
  }, {
    title: 'Dominar el marketing digital (TikTok, Instagram)',
    description: 'Atrae clientas constantemente con estrategias digitales probadas'
  }, {
    title: 'Profesionalizarte y generar ingresos reales',
    description: 'Convierte tu pasión en un negocio rentable y sostenible'
  }];
  return <section className="py-16 px-4" data-id="element-16">
      <div className="container mx-auto max-w-6xl" data-id="element-17">
        <div className="flex flex-col md:flex-row items-center gap-8 mb-12" data-id="element-18">
          <div className="md:w-1/2" data-id="element-19">
            <div className="relative" data-id="element-20">
              <img src="https://images.unsplash.com/photo-1632345031435-8727f6897d53?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Diseño de uñas profesional" className="rounded-lg shadow-xl w-full h-auto" data-id="element-21" />
              <div className="absolute -bottom-5 -right-5 bg-pink-500 text-white p-4 rounded-lg shadow-lg" data-id="element-22">
                <SearchIcon className="h-8 w-8" data-id="element-23" />
              </div>
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-24">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-25">
              Lo que aprenderás paso a paso:
            </h2>
            <div className="space-y-4" data-id="element-26">
              {courseModules.map((module, index) => <div key={index} className="flex items-start" data-id="element-27">
                  <CheckCircleIcon className="h-6 w-6 text-pink-500 mt-1 mr-3 flex-shrink-0" data-id="element-28" />
                  <div data-id="element-29">
                    <h3 className="text-lg font-semibold" data-id="element-30">{module.title}</h3>
                    <p className="text-gray-600" data-id="element-31">{module.description}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-32">
          <a href="https://nailmasterclasspro.mitiendanube.com/checkout/v3/start/1789839156/b96e63bc245079acd7af9657978acace71d015a6?from_store=1&country=AR" className="bg-gradient-to-r from-pink-500 to-purple-600 text-white px-8 py-4 rounded-full text-lg font-bold shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 inline-block" data-id="element-33">
            COMPRAR AHORA - $14.999
          </a>
        </div>
      </div>
    </section>;
}